import { render } from "./TriggerHistoryIndex.vue?vue&type=template&id=2052ca88"
import script from "./TriggerHistoryIndex.vue?vue&type=script&lang=js"
export * from "./TriggerHistoryIndex.vue?vue&type=script&lang=js"
script.render = render

export default script